import { render, staticRenderFns } from "./LKMunMehFormFooter.vue?vue&type=template&id=55a56440&scoped=true&"
import script from "./LKMunMehFormFooter.vue?vue&type=script&lang=js&"
export * from "./LKMunMehFormFooter.vue?vue&type=script&lang=js&"
import style0 from "./LKMunMehFormFooter.vue?vue&type=style&index=0&id=55a56440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a56440",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VLayout,VSpacer})
